import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Form, FormGroup, ControlLabel, FormControl, Button} from 'react-bootstrap';
import {getMetroArea} from 'reducers/reducer_metro_areas';
import ReactDOM from 'react-dom';
 import {makeRequest,dispatchAction,  displayMessage}  from 'actions';
import {FETCH_METRO_AREA, UPDATE_METRO_AREA, ADD_METRO_AREA} from "actions/actionTypes";

import {validateEmail}  from 'util/Utils';
class AdminMetroAreaAddEdit extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        console.log('in add metroareas' );
        super(props);
        this.state = {
            newRecord: this.props.location.pathname.includes('/metro-area/add') ? true : false,
        }
        this.addRecord = this.addRecord.bind(this);
        this.editRecord = this.editRecord.bind(this);
    }

    componentWillMount() {

        if (!this.state.newRecord && typeof this.props.metroarea == 'undefined') {
                var methodData = {
                    "success_event": FETCH_METRO_AREA,
                    'endpoint': '/metro-areas',
                    'not_display_success_message': true,
                };

                this.props.makeRequest({MetroAreaID: this.props.params.id}, methodData).then(res => {
                    console.log('res', res);

                });
            }
    }

    addRecord(e) {
        e.preventDefault();
        var objectData = this.prepareData();

        if (!objectData) {
            return
        }
         console.log('objectData',objectData );
            var methodData = {
                 type: 'post',
                endpoint: '/metro-areas',
                success_event:ADD_METRO_AREA,
                messageData: {'#1#': 'Metro Area'},
                messageCode: 'recordAdded'
            }
            this.props.makeRequest(objectData, methodData).then(function (response) {
                this.context.router.goBack();
        }.bind(this));
    }

    editRecord(e) {
        e.preventDefault();

        var objectData = this.prepareData();
        console.log('in edit',objectData);
        if (!objectData) {
            return
        }
        var methodData = {
            success_event: UPDATE_METRO_AREA,
            type: 'patch',
            endpoint: '/metro-areas/' + encodeURIComponent(this.props.metroarea._id),
            messageData: {'#1#': 'Metro Area'},
            messageCode: 'recordUpdated'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
          this.context.router.goBack();
        }.bind(this));
    }

    prepareData(e) {

        var objectData = {};
          objectData['Name'] = ReactDOM.findDOMNode(this.refs['Name']).value;

        var messageData = {
            'messageType': 'warning',
            'messageCode': 'errorFieldRequired'
        }

        if (objectData['Name'] == '') {
            this.props.displayMessage(_.extend(messageData, {'messageData': {'#1#': 'Name'}}));
            return false;
        }
        objectData['ZipCodes'] =      _.map( ReactDOM.findDOMNode(this.refs['ZipCodes']).value.split(','), zipCode=>{
            return _.trim(zipCode)
        })
                if ((!_.isUndefined(this.state.ReminderText))){
                    objectData.ReminderText =this.state.ReminderText
                }


        objectData['ZipCodes'] = _.filter(objectData['ZipCodes'], function (zipCode) {
               return zipCode !== '';
        })
        objectData['ZipCodes'] =  _.sortBy(objectData['ZipCodes'], zipCode=>{
            return parseInt(zipCode)
        })

        if (_.size(objectData['ZipCodes']) == 0) {
            this.props.displayMessage(_.extend(messageData, {'messageData': {'#1#': 'Zip Codes'}}));
            return false;
        }



        return objectData;

    }



    render() {
        console.log('this.state1', this.props,   this.state);
        var metroarea = this.props.metroarea;

        return (
            <div >
                <h4 className="left0">
                    {metroarea ? 'Edit metroarea' : 'Add new metroarea'}
                </h4>
                { this.state.newRecord || metroarea ? (
                    <Form onSubmit={this.state.newRecord ? this.addRecord : this.editRecord}>

                        <FormGroup style={{maxWidth:600}}>
                            <ControlLabel>Name</ControlLabel>
                            <FormControl type="text" defaultValue={metroarea ? metroarea.Name : '' }
                                         ref="Name"
                                         placeholder="Name"/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Zip Codes</ControlLabel>
                            <FormControl componentClass="textarea" rows="6"  defaultValue={metroarea ? metroarea.ZipCodes.join(', ')  : '' }
                                         ref="ZipCodes"
                                         placeholder="Zip Codes"/>
                        </FormGroup>
                        <FormGroup style={{maxWidth:600}}>
                            <ControlLabel>Fulfillment Reminder Text</ControlLabel>
                            <FormControl type="text" defaultValue={ _.get(metroarea,'ReminderText') }
                                         onChange={(event) => {
                                             this.setState({
                                                 'ReminderText': event.target.value
                                             })
                                         }}
                                         placeholder=""/>
                        </FormGroup>
                        <FormGroup>
                            <Button className="btn-primary" type="submit">
                                Save
                            </Button>
                        </FormGroup>
                    </Form>
                ) : ''}
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    console.log('getMetroAr1ea',getMetroArea(state, props.params.id));
    return {metroarea: getMetroArea(state, props.params.id)};
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction,  displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminMetroAreaAddEdit);
